export default __webpack_public_path__ + "static/media/alert-icon-gray.8c6c8879.svg";